import * as React from 'react';
import { Dispatch, connect } from 'react-redux';
import * as moment from 'moment';
import { toast } from "react-toastify";
import * as _ from 'lodash';
import { ISortBy, IBaseResponse, IApSbsItem } from '@nkr/models/index';
import { IBillingState, BillingActionCreators, IApplicationState, AppActionCreators, IApSbsResponse } from '@nkr/store/index';
import { Glyphicon, FormControl, Row, ButtonToolbar, ToggleButtonGroup, ToggleButton, Col, Button } from 'react-bootstrap';
import SbsRow from './sbs-row';
import { statusMap } from '../../center-admin/billing/status-map';
import { TableWrapper } from '../../center-admin/billing/styles';
import NoData from '../../center-admin/billing/no-data';
import { downloadFile } from '../../../services/download-file';

interface IOwnProps {
}

interface IStateProps {
    billing: IBillingState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getApSbsReport: (isToDo : boolean, startDate : string, endDate : string) => Promise<IApSbsResponse>,
    getSBSTransplantFeesResults: () => Promise<any>,
    updatePayment: (sbsItem: IApSbsItem) => Promise<IBaseResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    sortBy          : ISortBy[],
    billingReport   : IApSbsItem[],
    isToDo          : boolean,
    startDate       : string,
    endDate         : string

}

class BilledByCenter extends React.Component<TProps, IState> {
    readonly state: IState = {
        sortBy          : [],
        billingReport   : [],
        isToDo          : true,
        startDate       : null,
        endDate         : null
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting payables, one moment please...').then(() => {
            this.props.getApSbsReport(this.state.isToDo, this.state.startDate, this.state.endDate)
                .then((response: IApSbsResponse) => {
                    this.setState({
                        sortBy: [{property: 'payDate', direction: 'asc'}],
                        billingReport: response.data.results
                    });

                    this.props.hideLoading();
                });
        });
    }

    updateToDo = ( isToDo : boolean ) => {
        var endDate     = isToDo ? null : moment().format("YYYY-MM-DD");
        var startDate   = isToDo ? null : moment().subtract(1,'year').format("YYYY-MM-DD");
        this.setState({isToDo, startDate, endDate});
        this.getData();
    }
    updateStartDate = ( e ) => {
        var startDate = e.target.value;
        this.setState({startDate});
    }
    updateEndDate = ( e ) => {
        var endDate = e.target.value;
        this.setState({endDate});
    }

    handleSort = (property: string) => {
        let sortBy = _.cloneDeep(this.state.sortBy);
        if (!this.state.sortBy.some(s => s.property == property))
            sortBy = [];

        let sort = sortBy.find(item => item.property == property);

        if (sort != null) {
            if (sort.direction == 'asc')
                sort.direction = 'desc'
            else
                if (sort.direction == 'desc')
                    sortBy = sortBy.filter(item => item.property != property);
        } else {
            sortBy.push({ property, direction: 'asc' });
        }

        this.setState({
            sortBy
        });
    }

    handlePaymentUpdate = (sbsItem: IApSbsItem) => {
        this.props.showLoading('Getting invoices, one moment please...').then(() => {
            this.props.updatePayment(sbsItem)
                .then((response: IBaseResponse) => {

                    if (response.data.success) {
                        // this.getData();
                        //update existing item without getting new set of data
                        toast.success("Swap '" + sbsItem.swap + "' has been marked paid");
                    }

                    this.props.hideLoading();
                });
        });
    }

    checkNumbers = (value: string) => {
        switch (value) {
            case 'daysOutstanding':
            case 'surgeonFee':
            case 'hospitalFee':
            case 'anesFee':
            case 'totalFees':
            case 'swapNumber':
            case 'hasAch':
                    return true;
            default: return false;
        }
    }

    getRows = () => {
        const sortByProperties = this.state.sortBy.map((sortBy) => sortBy.property);
        const sortByDirections = this.state.sortBy.map((sortBy) => sortBy.direction);
        const filteredRows = this.state.billingReport;

        if (sortByProperties.some(this.checkNumbers)) {
            var sortedRows = this.state.sortBy.length > 0 ? _.orderBy(filteredRows, (item) => {
                return Number(sortByProperties.map(sortBy => {
                    // if(item.paidDateTime == null)
                    //     return -2;


                    switch (sortBy) {
                        case 'swap': return parseInt(item.swap);
                        case 'daysOutstanding':
                            return item.daysOutstanding;
                        case 'surgeonFee':
                            return item.surgeonFee;
                        case 'hospitalFee':
                            return item.hospitalFee;
                        case 'anesFee':
                            return item.anesthesiologistFee;
                        case 'totalFees':
                            return item.totalFees;
                        case 'swapNumber':
                                return item.swapNumber;
                        case 'hasAch':
                            //do logic to calculate payment estimated date status
                            var currentStatus = item.centerHasAchOnFile 
                                ? 0 //hasAch
                                : 1;

                            return currentStatus;
                    }
                    return item[sortBy];
                }));
            }, sortByDirections) : filteredRows;
        } else {
            var sortedRows = this.state.sortBy.length > 0 ? _.orderBy(filteredRows, (item) => {
                return sortByProperties.map(sortBy => {
                    switch (sortBy) {
                        case 'paidDate': return moment(item.paidDateTime).format('YYMMDD');
                        case 'donorCenterAlias': return item.donorCenterAlias.toLowerCase();
                        case 'donorAlias': return item.donorAlias;
                        case 'recipientCenterAlias': return item.recipientCenterAlias.toLowerCase();
                        case 'recipientAlias': return item.recipientAlias;
                        case 'achConfirmation': return item.achConfirmation;
                        case 'payDate': 
                            if(item.ccbPayableDays != undefined)
                                return moment(item.invoiceDate).add(item.ccbPayableDays).format('YYMMDD');
                            else 
                                return '991212'
                    }
                    return item[sortBy];
                });
            }, sortByDirections) : filteredRows;
        }


        return sortedRows;
    }

    handleGetSBSTransplantFees = () => {
        this.props.getSBSTransplantFeesResults().then((response: any) => {
            downloadFile(response.data, `transplant-results.csv`, 'text/csv');
        });
    }

    renderHeaderSort = (property: string) => {
        let sortItem = this.state.sortBy.find(item => item.property == property);

        if (sortItem != null) {
            return <Glyphicon glyph={sortItem.direction == 'asc' ? 'triangle-top' : 'triangle-bottom'} style={{ marginLeft: 5 }} />;
        } else {
            return null;
        }
    }

    render = () => {
        const rows = this.getRows();
        const missingAchInfo = true; //rows.map(x => !x.achConfirmation); // talk to kev about the column reference
        const showAlert = rows.length > 0 && missingAchInfo

        return (
            <>
                <div className="row">
                    <div className="col-xs-12 col-sm-10 col-md-6"><h3>Accounts Payable - Center Nephrectomy</h3></div>
                    <div className="col-xs-12 col-sm-2 col-md-6">
                        <br /><Button className="pull-right" bsStyle='warning' onClick={() => this.handleGetSBSTransplantFees()}>Export to CSV</Button>
                    </div>
                </div>

                <Row>
                    <Col xs={12} sm={3} md={3} lg={2}>
                        <h5>Statuses:</h5>
                        <ButtonToolbar>
                            <ToggleButtonGroup name="isToDo" type="radio" defaultValue={[this.state.isToDo ? 1 : 0]}>
                                <ToggleButton value={1}
                                    onClick={() => this.updateToDo(true)}>
                                        To-Do
                                </ToggleButton>
                                <ToggleButton value={0}
                                    onClick={() => this.updateToDo(false)}>
                                        Paid
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </ButtonToolbar>
                    </Col>
                    {this.state.isToDo === false && 
                        <>
                        <Col xs={6} sm={3}>
                            <h5>Start:</h5>
                            <input className="form-control" type="date" name="startDate" value={this.state.startDate} onChange={this.updateStartDate} />
                        </Col>
                        <Col xs={6} sm={3}>
                            <h5>End:</h5>
                            <input className="form-control" type="date" name="endDate" value={this.state.endDate} onChange={this.updateEndDate} />
                        </Col>
                        <Col xs={12} sm={3}>
                            <h5>&nbsp;</h5>
                            <Button className='btn-primary' onClick={this.getData}>Update</Button>
                        </Col>
                        </>
                    }
                </Row>

                <br />
                {rows.length > 0 ?
                    <TableWrapper striped>
                        <thead>
                            <tr>
                                <th>Rank</th>
                                <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('swapNumber')}>Swap {this.renderHeaderSort('swapNumber')}</th>
                                <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('invoiceDate')}>Invoiced {this.renderHeaderSort('invoiceDate')}</th>
                                <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('daysOutstanding')}>Days {this.renderHeaderSort('daysOutstanding')}</th>
                                <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('donorCenterAlias')}>D<br />Center {this.renderHeaderSort('donorCenterAlias')}</th>
                                <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('donorAlias')}>D<br />Alias {this.renderHeaderSort('donorAlias')}</th>
                                <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('recipientCenterAlias')}>R<br />Center {this.renderHeaderSort('recipientCenterAlias')}</th>
                                <th style={{ cursor: 'pointer', width: '10px' }} onClick={() => this.handleSort('recipientAlias')}>R<br />Alias {this.renderHeaderSort('recipientAlias')}</th>
                                <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('surgeonFee')}>Surgeon<br />Fee {this.renderHeaderSort('surgeonFee')}</th>
                                <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('anesFee')}>Anesth<br />Fee  {this.renderHeaderSort('anesFee')}</th>
                                <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('hospitalFee')}>Hospital<br />Fee {this.renderHeaderSort('hospitalFee')}</th>
                                <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('totalFees')}>Total<br />Fees {this.renderHeaderSort('totalFees')}</th>
                                <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('payDate')}>Pay<br />Date {this.renderHeaderSort('payDate')}</th>
                                <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('hasAch')}>Has<br />ACH {this.renderHeaderSort('hasAch')}</th>
                                <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('paidDate')}>Paid<br />Date {this.renderHeaderSort('paidDate')}</th>
                                <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('achConfirmation')}>ACH {this.renderHeaderSort('achConfirmation')}</th>
                                <th>Comments</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((item, index) =>
                                <SbsRow
                                    rank={index + 1}
                                    data={item}
                                    updatePayment={this.handlePaymentUpdate}
                                />
                            )}
                        </tbody>
                    </TableWrapper>
                    :
                    <NoData message={'No payables found matching criteria...'} />
                }
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        billing: appState.billing
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getApSbsReport: (isToDo : boolean, startDate : string, endDate : string) => { return dispatch(BillingActionCreators.getApSbsReport(isToDo,startDate,endDate)); },
        getSBSTransplantFeesResults: () => { return dispatch(BillingActionCreators.getSBSTransplantFeesResults()); },
        updatePayment: (sbsRowItem) => { return dispatch(BillingActionCreators.updateApSbsItem(sbsRowItem)); }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(BilledByCenter);